// extracted by mini-css-extract-plugin
export default {"root":"AuthLayout_root__MqHtv","content":"AuthLayout_content__KPecx"};